module.exports = __webpack_public_path__ + "static/img/wx_selec.2ef2a1a5.svg";